export default "__VITE_ASSET__BLcDq5yz__"